<template>
  <div>
    ss
  </div>
</template>

<script>
export default {
  name: 'liveStats',
  prop: ['match'],
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/sportsbook/widget/liveStats.vue